
import {Component, Vue} from 'vue-property-decorator'
import UserInfo from '@/model/modules/UserInfo'
import UserInfoService from '@/service/modules/UserInfoService'
import UserGroupInfo from '@/model/modules/UserGroupInfo'
import UserGroupService from '@/service/modules/UserGroupService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'

@Component
export default class UserLevelGroupEditor extends Vue {
  item: UserInfo = new UserInfo()
  showState: boolean = false
  savingState: boolean = false
  saveSuccessCallback: any
  userGroupOptions: UserGroupInfo[] = []

  showEditor(item: UserInfo, saveSuccessCallback: any) {
    this.refreshUserGroupOptions()
    this.item = JSON.parse(JSON.stringify(item))
    this.item.deposit /= 100
    this.saveSuccessCallback = saveSuccessCallback
    this.showState = true
  }

  refreshUserGroupOptions() {
    UserGroupService.list({}, 0, 99999)
      .then((result: BasePageableInfo<UserGroupInfo>) => {
        this.userGroupOptions = result.dataList
      })
  }

  saveEditor() {
    this.savingState = true
    const savedItem: UserInfo = JSON.parse(JSON.stringify(this.item))
    savedItem.deposit = Math.floor(savedItem.deposit * 100)
    if (savedItem.id === 0) {
      delete savedItem.id
    }
    UserInfoService.save(savedItem)
      .then(() => {
        this.$alert('保存数据', '保存成功', {
          confirmButtonText: '确定'
        })
        this.savingState = false
        this.showState = false
        this.saveSuccessCallback()
      })
  }
}
